import React, { useEffect, useRef, useState } from "react";
import { Container, Collapse, Button, Typography, Table, TableCell, TableBody, TableRow, TableHead, TableContainer, Card, TextField, FormControl, Grid, CardContent, Dialog, Stack, IconButton, DialogContent, DialogActions, Box, Breadcrumbs, Link } from "@mui/material";
import Scrollbar from "src/components/Scrollbar";
import axios from "axios";
import { getURL, jsonToParam, jsonToFormData } from "src/utils/config";
import Iconify from "src/components/Iconify";
import Page from "src/components/Page";
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import { Edit, Delete } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

const OperationsTeam = () => {
  const [email, setEmail] = useState("");
  const [agentName, setAgentName] = useState("");
  const [agentNumber, setAgentNumber] = useState("");
  const [title, setTitle] = useState("");
  const [userNewName, setNewUsername] = useState("");
  const [password, setPassword] = useState("");

  const [addError, setAddError] = useState("");
  const [updateError, setUpdateError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [agentNameError, setagentNameError] = useState("");
  const [successDialog, setSuccessDialog] = useState(false);

  const [userNewNameError, setuserNewNameError] = useState("");
  const [passwordError, setpasswordTypeError] = useState("");

  const [visiblePasswordIndex, setVisiblePasswordIndex] = useState(null);

  //Edit Dailog box
  const [openDialogEdit, setOpenDialogEdit] = useState(false);

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState("md");

  const [isEdited, setIsEdited] = useState(false);
  const [prvValue, setPrvValue] = useState("");

  const [userData, setUserData] = useState({});

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [openMessage, setOpenMessage] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState(false);
  const [subLogin, setSubLoginList] = useState([]);
  const [originalData, setOriginalData] = useState([])
  const [showForm, setShowForm] = useState(false);
  const [showAdd, setShowAdd] = useState(true);
  //const [isEdited,setIsEdited] = useState(false)
  const [indexHist, setIndexHist] = useState(null)
  const [successEditDialog, setSuccessEditDialog] = useState(false)
  const formRef = useRef(null);

  const AUTHORIZATION = `Bearer ${localStorage.getItem("access_token")}`;

  useEffect(() => {
    getSubLogins();
  }, []);

  const getSubLogins = () => {
    const userId = Number(localStorage.getItem("ID"));

    axios({
      method: "get",
      url: `${getURL("/client/client-users")}?client_id=${userId}&type=tenent`,
      headers: {
        Authorization: `${AUTHORIZATION}`,
      },
      validateStatus: function (status) {
        return status >= 200 || status === 400;
      },
    }).then(function (response) {
      if (response.status === 200) {
        // Check if each item in response.data has a Title field, if not, set it to ""
        if (Array.isArray(response.data)) {
          response.data = response.data.map(item => ({
            ...item,
            Title: (item.Title !== undefined && item.Title !== null) ? item.Title : ""
          }));
        }
        setSubLoginList(response.data);
      } else {
        console.log(response.data);
      }
    });
  };

  const [dialogData, setDialogData] = useState({
    email: "",
    agentName: "",
    agentNumber: "",
    title:"",
  });

  const [editedData, seteditedData] = useState({
    Id: "",
    UserID: "",
    email: "",
    title:"",
    agentName: "",
    agentNumber: "",
  });

  const handleEmailChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, email: event.target.value });
      setEmail(event.target.value);
    } else {
      seteditedData({ ...editedData, email: event.target.value });
    }
  };

  const handleTitleChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, title: event.target.value });
      setTitle(event.target.value);
    } else {
      seteditedData({ ...editedData, title: event.target.value });
    }
  };

  const handleAgentNameChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, agentName: event.target.value });
      setAgentName(event.target.value);
    } else {
      seteditedData({ ...editedData, agentName: event.target.value });
    }
  };

  const handleAgentPhoneNumberChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, agentNumber: event.target.value });
      setAgentNumber(event.target.value);
    } else {
      seteditedData({ ...editedData, agentNumber: event.target.value });
    }
  };


  function isUniqueValue(newName, newEmail, subLogin) {
    let isValid = true
    for (const login of subLogin) {
      // Check case-insensitive duplicate
      if (
        login.UserName &&
        login.UserName.toLowerCase() === newName.toLowerCase()
      ) {
        setagentNameError("Name already exists");
        isValid = false;
      }

      if (login.Email === newEmail) {
        setEmailError("Email Already Exists");
        isValid = false;
      }
    }
    return isValid;
  }

  function isUniqueEditValue(newName, newEmail, subLogin, currentId) {
    let valid = true;

    // Reset previous errors
    setEditProfileNameError("");
    setEditEmailError("");
    

    for (const login of subLogin) {
      // Skip the same user being edited
      if (login.Id === currentId) continue;

      // Check Name
      if (
        login.UserName &&
        login.UserName.toLowerCase() === newName.toLowerCase()
      ) {
        setEditProfileNameError("Name already exists");
        valid = false;
      }

      if (login.Email && login.Email.toLowerCase() === newEmail.toLowerCase()) {
        setEditEmailError("Email already exists");
        valid = false;
      }
    }

    return valid;
  }

  const handleSubmit = () => {
    let Count = 0;

    clearFieldErrors();

    const addEmail = email.trim();
    const addAgentName = agentName.trim();
    const addAgentNumber = agentNumber.trim();
    const addTitle = title.trim();

    if (!addEmail) {
      setEmailError("Please Enter the Email");
      Count = 1;
    }

    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (addEmail && !emailRegex.test(addEmail)) {
      setEmailError("Please Enter the Valid Email");
      Count = 1;
    }

    if (!addAgentName) {
      setagentNameError("Please Enter the Name");
      Count = 1;
    }


    if (Count === 0) {
      if (!isUniqueValue(addAgentName, addEmail, subLogin)) {
        return;
      } else {
        const userId = String(localStorage.getItem("ID"));

        const data = {
          UserID: userId,
          Name: addAgentName,
          Email: addEmail,
          ContactNo: addAgentNumber.toString(),
          Title: addTitle,
          Type: "tenent",
        };

        axios({
          method: "post",
          url: getURL("/client/add-client-users"),
          data: data,
          headers: {
            Authorization: `${AUTHORIZATION}`,
          },
          validateStatus: function (status) {
            return status >= 200 || status === 400;
          },
        }).then(function (response) {
          if (response.status === 200) {
            handleClear();
            getSubLogins();
            setSuccessDialog(true);
          } else {
            //console.log("addError:", response.data.detail);
            setAddError(response.data.detail);

            setTimeout(() => {
              clearAlertMsgs();
            }, 3000);
          }
        });
      }
    }
  };

  const clearAlertMsgs = () => {
    setAddError("");
    setUpdateError("");
  };

  const clearFieldErrors = () => {
    clearAlertMsgs();

    setEditEmailError("");
    setEditProfileNameError("");

    setEmailError("");
    setagentNameError("");
    setuserNewNameError("");
    setpasswordTypeError("");
  };

  const handleClear = () => {
    clearFieldErrors();

    setEmail("");
    setAgentName("");
    setNewUsername("");
    setPassword("");
    setAgentNumber("");
    setTitle("");
  };

  const toggleForm = () => {
    if (showForm) {
      setShowForm(false);
      setShowAdd(true);
      handleClear();
    } else {
      setShowForm(true);
      setShowAdd(false);

      setTimeout(() => {
        if (formRef.current) {
          formRef.current.focus();
          const firstInput = formRef.current.querySelector("input");
          if (firstInput) firstInput.focus();
        }
      }, 100);
    }
  };

  const handleEdit = (data, index) => {

    setIndexHist(index)
    const userId = String(localStorage.getItem("ID"));

    const editData = {
      Id: data.Id,
      email: data.Email,
      agentName: data.UserName,
      UserID: userId,
      title:data.Title,
      agentNumber: data.ContactNo,
    };

    console.log(editData);

    setShowMessage(false);
    seteditedData(editData);
    setOriginalData(JSON.parse(JSON.stringify(subLogin[index])));
    //setOpenDialogEdit(true);
  };

  //console.log('editedData:', editedData)

  const [showMessage, setShowMessage] = useState(false);

  const [editProfileNameError, setEditProfileNameError] = useState("");
  const [editProfileNumberError, setEditProfileNumberError] = useState("");
  const [editEmailError, setEditEmailError] = useState(""); 
  const [editTitleError, setEditTitleError] = useState("");
  const [editMobileNumberError, setEditMobileNumberError] = useState("");

  const handleUpdated = () => {
    let count = 0;

    clearFieldErrors();

    const userId = String(localStorage.getItem("ID"));

    console.log('editedData:', editedData)

    const editEmail = editedData.email.trim();
    const editAgentName = editedData.agentName.trim();
    const editTitle = editedData.title.trim();
    const editAgentNumber = editedData.agentNumber.trim();

    if (!editEmail) {
      setEditEmailError("Please Enter the Email");
      count = 1;
    }
    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (editEmail && !emailRegex.test(editEmail)) {
      setEditEmailError("Please Enter the Valid Email");
      count = 1;
    }

    if (!editAgentName) {
      setEditProfileNameError("Please Enter the Name");
      count = 1;
    }


    if (
      count === 0 &&
      editEmail !== "" &&
      editEmail !== null &&
      editAgentName !== "" &&
      editAgentName !== null
    ) {
      if (
        !isUniqueEditValue(
          editAgentName,
          editEmail,
          subLogin,
          editedData.Id
        )
      ) {
        return;
      } else {
        const updateData = {
          ID: editedData.Id,
          UserID: userId,
          Email: editEmail,
          Name: editAgentName,
          Title: editTitle,
          //Name: editedData.userNewName.trim(),
          //Password: editedData.password.trim(),
          Type: "tenent",
          Status: 1,
          ContactNo: editAgentNumber,
        };
        axios({
          method: "put",
          url: getURL("/client/update-client-users"),
          data: updateData,
          headers: {
            Authorization: `${AUTHORIZATION}`,
          },
          validateStatus: function (status) {
            return status >= 200 || status === 400;
          },
        }).then(function (response) {
          if (response.status === 200) {
            setSuccessEditDialog(true)
            //setOpenDialogEdit(false);
            handleClear();
            getSubLogins();
            seteditedData([])
            setIndexHist(null)
          } else {
            //console.log('updateError:', response.data.detail);
            setUpdateError(response.data.detail);

            setTimeout(() => {
              clearAlertMsgs();
            }, 3000);
          }
        });
      }
    }
  };

  const handleClose = () => {
    setOpenDialogEdit(false);
    setIsEdited(false);
    setPrvValue("");
    setShowMessage(false);
    setOpenMessage(false);
    setDeleteMessage(false);
    setUserData({});

    setEditEmailError("");
    setEditProfileNameError("");
  };



  const handleDelete = (data) => {
    setDeleteMessage(true);
    setUserData(data);
  };

  const deleteUser = () => {
    const deleteUserData = {
      ID: userData.Id,
    };

    axios({
      method: "delete",
      url: getURL(`/client/delete`),
      data: jsonToFormData(deleteUserData),
      headers: {
        Authorization: `${AUTHORIZATION}`,
      },
      validateStatus: function (status) {
        return status >= 200 || status === 400;
      },
    }).then(function (response) {
      if (response.status === 200) {
        setDeleteMessage(false);
        getSubLogins();
        //console.log("User deleted successfully!");
      } else {
        console.log("deleteError:", response.data.detail);
      }
    });
  };

  const updateUserStatus = () => {
    const newStatus = userData.Status === 1 ? 0 : 1;

    const updateData = {
      ID: userData.Id,
      Status: newStatus,
    };

    axios({
      method: "put",
      url: getURL("/client/update-status"),
      data: jsonToParam(updateData),
      headers: {
        Authorization: `${AUTHORIZATION}`,
      },
      validateStatus: function (status) {
        return status >= 200 || status === 400;
      },
    }).then(function (response) {
      if (response.status === 200) {
        setOpenMessage(false);
        getSubLogins();
        //console.log("Status updated successfully!");
      } else {
        console.log("updateError:", response.data.detail);
      }
    });
  };

  return (
    <Page title="Operations Team">
      <Container maxWidth="xxl">
      <Box sx={{ mb: 4 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4">Operations Team</Typography>
          <Button
            variant="contained"
            onClick={toggleForm}
            startIcon={showAdd ? <AddIcon /> : <CloseIcon />}
            sx={{
              color: "#ffffff",
              backgroundColor: "#5c7fff",
              "&:hover": {
                backgroundColor: "#1E3A8A",
                color: "#ffffff",
              },
            }}
          >
            {showAdd ? "Add Operations Team" : "Close"}
          </Button>
        </Box>
        <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
          <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>
            Operations Team
          </Typography>
        </Breadcrumbs>
      </Box>

      <Card variant="outlined" sx={{ marginBottom: "8px" }}>
        <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
            {/* <Scrollbar> */}
              <TableContainer>
                <Box sx={{ maxHeight: 600 }}>
                  <Table stickyHeader >
                    <TableHead sx={{ background: "#f3f3f3" }}>
                      <TableRow sx={{ background: "#f3f3f3" }}>
                        {/* <TableCell align="center">S.No</TableCell> */}
                        <TableCell align="center">Name</TableCell>
                        <TableCell align="center">Title</TableCell>
                        <TableCell align="center">Email</TableCell>
                        <TableCell align="center">Mobile Number</TableCell>
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{
                    }}>
                      {subLogin.length > 0 ? (
                        subLogin.map((data, index) => (
                          <TableRow key={index}>
                            {/* <TableCell align="center" style={{ width: '100px', ...(indexHist === index ? { paddingBottom: '20px' } : {}) }}>{index + 1}</TableCell> */}

                            <TableCell align="center" style={{width:"200px"}}>
                              {(indexHist === index) ?
                                <Grid container spacing={2} sx={{ marginTop: '20px', paddingBottom: "5px" }}>
                                  <TextField
                                    fullWidth
                                    id="agent-name"
                                    variant="outlined"
                                    value={editedData.agentName}
                                    label="Name"
                                    onChange={(e) => handleAgentNameChange(e, "edit")}
                                    //error={agentNameError ? true : false}
                                    error={!!editProfileNameError}
                                    helperText={editProfileNameError || "\u00A0"}
                                  />
                                </Grid>
                                : (data.UserName)}
                            </TableCell>
                            <TableCell align="center" style={{width:"250px"}}>
                              {(indexHist === index) ?
                                <Grid container spacing={2} sx={{ marginTop: '20px', paddingBottom: "5px" }}>
                                  <TextField
                                    fullWidth
                                    id="title"
                                    variant="outlined"
                                    value={editedData.title}
                                    label="Title"
                                    onChange={(e) => handleTitleChange(e, "edit")}
                                    error={!!editTitleError}
                                    helperText={editTitleError || "\u00A0"}
                                  />
                                </Grid>
                                : (data.Title)}
                            </TableCell>
                           
                            <TableCell align="center" style={{width:"300px"}}>
                              {(indexHist === index) ?
                                <Grid container spacing={2} sx={{ marginTop: '20px', paddingBottom: "5px" }}>
                                  <TextField
                                    fullWidth
                                    id="email"
                                    variant="outlined"
                                    value={editedData.email}
                                    label="Email"
                                    onChange={(e) => handleEmailChange(e, "edit")}
                                    error={!!editEmailError}
                                    helperText={editEmailError || "\u00A0"}
                                  />
                                </Grid>
                                : (data.Email)}
                            </TableCell>
                            <TableCell align="center" style={{width:"200px"}}>
                              {(indexHist === index) ?
                                <Grid container spacing={2} sx={{ marginTop: '20px', paddingBottom: "5px" }}>
                                  <TextField
                                    fullWidth
                                    id="agent-number"
                                    variant="outlined"
                                    value={editedData.agentNumber}
                                    label="Mobile Number"
                                    onChange={(e) => {
                                      const onlyNums = e.target.value.replace(
                                        /[^0-9]/g,
                                        ""
                                      ); // removes non-numeric
                                      handleAgentPhoneNumberChange(
                                        { target: { value: onlyNums } },
                                        "edit"
                                      );
                                    }}
                                    inputProps={{ maxLength: 15 }} // optional: restrict to 10 digits
                                    error={!!editMobileNumberError}
                                    helperText={editMobileNumberError || "\u00A0"}
                                  />
                                </Grid>
                                : (data.ContactNo)}
                            </TableCell>
                            <TableCell  align="center" style={{width:"250px"}}>
                              <Grid container spacing={2} justifyContent="center" alignItems="center">
                                {(indexHist === index) ? (
                                  <Box
                                    sx={{ paddingBottom: "5px", marginTop: '20px',
                                      display: "flex", gap: "6px", justifyContent: "center" }}>
                                    <Button
                                      variant="contained"
                                      onClick={handleUpdated}
                                      sx={{
                                        marginRight: { xs: 0, sm: "6px" },
                                        marginBottom: { xs: "8px", sm: "3px" },
                                        color: "#ffffff",
                                        '&:hover': {
                                          color:'#ffffff',
                                        }
                                      }}
                                    >Save</Button>
                                    <Button
                                      variant="contained"
                                      onClick={() => {
                                        setIsEdited(false);
                                        setIndexHist(null);
                                        setEditEmailError("")
                                        setEditProfileNameError("")
                                      }}
                                      //sx={{ marginLeft: '3px' }}
                                      sx={{
                                        marginRight: { xs: 0, sm: "3px" },
                                        marginBottom: { xs: "8px", sm: "3px" },
                                        color: "#ffffff",
                                        '&:hover': {
                                          color:'#ffffff',
                                        }
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </Box>
                                ) : (
                                  <>
                                    <Box sx={{ marginTop: "15px",
                                        display: "flex", gap: "6px", justifyContent: "center" }}>
                                      <Button
                                        variant="contained"
                                        onClick={() => handleEdit(data, index)}
                                        disabled={data.Status === 0}
                                        sx={{
                                          marginRight: { xs: 0, sm: "6px" },
                                          marginBottom: { xs: "8px", sm: "3px" },
                                          color: "#ffffff",
                                          backgroundColor: data.Status === 0
                                            ? "gray"
                                            : "#5c7fff",
                                          '&:hover': {
                                            color: "#ffffff",
                                          }
                                        }}
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        variant="contained"
                                        onClick={() => {
                                          handleDelete(data)
                                        }}
                                        sx={{
                                          marginRight: { xs: 0, sm: "3px" },
                                          marginBottom: { xs: "8px", sm: "3px" },
                                          color: "#ffffff",
                                          '&:hover': {
                                            color:'#ffffff',
                                          }
                                        }}
                                      >
                                        Delete
                                      </Button>
                                    </Box>
                                  </>
                                )}
                              </Grid>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={6}
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          >
                            No Data
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
            {/* </Scrollbar> */}
        </CardContent>
      </Card>

      {showForm && (
        <Collapse in={showForm} timeout={300} unmountOnExit>
          <Box ref={formRef} tabIndex={-1}>
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={2}>
                    <FormControl fullWidth>
                      <TextField
                        id="agent-name"
                        variant="outlined"
                        value={agentName}
                        label="Name"
                        onChange={(e) => handleAgentNameChange(e, "add")}
                        //error={agentNameError ? true : false}
                        error={!!agentNameError}
                        helperText={agentNameError || ""}
                      />
                      {/* {agentNameError && <Typography color="error" variant="body2"  >{agentNameError}</Typography>} */}
                    </FormControl>
                  </Grid>

                  <Grid item xs={6} sm={2}>
                    <FormControl fullWidth>
                      <TextField
                        id="agent-number"
                        variant="outlined"
                        value={title}
                        label="Title"
                        onChange={(e) => handleTitleChange(e, "add")}
                        error={false}
                        helperText={""}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <FormControl fullWidth>
                      <TextField
                        id="email"
                        variant="outlined"
                        value={email}
                        label="Email"
                        onChange={(e) => handleEmailChange(e, "add")}
                        //error={emailError ? true : false}
                        error={!!emailError}
                        helperText={emailError || ""}
                      />
                      {/* {emailError && <Typography color="error" variant="body2"  >{emailError}</Typography>} */}
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <FormControl fullWidth>
                      <TextField
                        id="agent-number"
                        variant="outlined"
                        value={agentNumber}
                        label="Mobile Number"
                        onChange={(e) => {
                          const onlyNums = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ); // removes non-numeric
                          handleAgentPhoneNumberChange(
                            { target: { value: onlyNums } },
                            "add"
                          );
                        }}
                        inputProps={{ maxLength: 15 }} // optional: restrict to 10 digits
                        error={false}
                        helperText={""}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={2} sx={{ height: "100%", marginTop: "10px" }}>
                    <Button
                      variant="contained"
                      onClick={handleSubmit}
                      disabled={isButtonDisabled}
                      sx={{
                        marginRight:'6px',
                        color: "#ffffff",
                        '&:hover': {
                          color:'#ffffff',
                        }
                      }}
                    >
                      Add
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleClear}
                      sx={{
                        color: "#ffffff",
                        '&:hover': {
                          color:'#ffffff',
                        }
                      }}
                    >
                      Clear
                    </Button>
                  </Grid>
                  {addError && (
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      marginTop={4}
                      marginLeft={1}
                    >
                      <Typography color="error">{addError}</Typography>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Box>
        </Collapse>
      )}

      {/* <Zoom in={showSticker} timeout={300}>
        <Tooltip
          title={showAdd ? "Add Operations Team" : "Close"}
          placement="right"
          arrow
        >
          <Fab
            color="primary"
            aria-label="add-protocol"
            onClick={toggleForm}
            size="small"
            sx={{
              position: "fixed",
              bottom: 24,
              right: 24,
              zIndex: 1000,
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s ease-in-out",
              },
            }}
          >
            {showAdd && !showClose ? (
              <AddIcon />
            ) : showClose && !showAdd ? (
              <CloseIcon />
            ) : (
              ""
            )}
          </Fab>
        </Tooltip>
      </Zoom> */}




      <Dialog open={openMessage} onClose={handleClose}>
        <DialogContent>
          <Stack
            //  direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ maxWidth: 350, textAlign: "center" }}
          >
            <Iconify
              icon={"eva:alert-triangle-outline"}
              sx={{ fontSize: 92, color: "#ffb2a3" }}
            />
            <Typography sx={{ color: "gray" }} variant="h5">
              {" "}
              Are you sure you want to{" "}
              {userData.Status === 1 ? "Disable" : "Enable"} this operations team:{" "}
              {userData.UserName}?
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} sx={{
            color: "#ffffff",
              '&:hover': {
                color:'#ffffff',
              }
          }}>
            No
          </Button>
          <Button variant="contained" onClick={updateUserStatus} sx={{
            color: "#ffffff",
            '&:hover': {
              color:'#ffffff',
            }
          }}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteMessage} onClose={handleClose}>
        <DialogContent>
          <Stack
            //  direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ maxWidth: 350, textAlign: "center" }}
          >
            <Iconify
              icon={"eva:alert-triangle-outline"}
              sx={{ fontSize: 92, color: "#ffb2a3" }}
            />
            <Typography sx={{ color: "gray" }} variant="h5">
              {" "}
              Are you sure you want to delete the operations team: {userData.UserName}?
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} sx={{
            color: "#ffffff",
              '&:hover': {
                color:'#ffffff',
            }
          }}>
            No
          </Button>
          <Button variant="contained" onClick={deleteUser} sx={{
            color: "#ffffff",
            '&:hover': {
              color:'#ffffff',
            }
          }}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={successDialog} onClose={() => setSuccessDialog(false)}>
        <DialogContent>
          <Stack
            justifyContent="center"
            alignItems="center"
            sx={{ maxWidth: 350, textAlign: "center" }}
          >
            <Typography sx={{ color: "gray" }} variant="h5">
            Operations Team added successfully!
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" sx={{
            color: "#ffffff",
            '&:hover': {
              color:'#ffffff',
            }
          }} onClick={() => setSuccessDialog(false)}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={successEditDialog} onClose={() => setSuccessEditDialog(false)}>
        <DialogContent>
          <Stack
            justifyContent="center"
            alignItems="center"
            sx={{ maxWidth: 350, textAlign: "center" }}
          >
            <Typography sx={{ color: "gray" }} variant="h5">
             Operations Team updated successfully!
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" sx={{
            color: "#ffffff",
            '&:hover': {
              color:'#ffffff',
            }
          }} onClick={() => setSuccessEditDialog(false)}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      </Container>
    </Page>
  );
};

export default OperationsTeam;
